import DisciplesRepository from './disciplesRepository';
import RolesRepository from './rolesRepository';
import DepthChartsRepository from './depthChartsRepository';
import BibleStudyPlansRepository from './BibleStudyPlanRepository';
import PeopleRepository from './peopleRepository';
import GraduationRecordsRepository from './graduationRecordsRepository';
import LocationsRepository from './locationsRepository';
import DiscipleshipGroupsRepository from './discipleshipGroupsRepository';
import RecruitmentDepthChartRepository from './recruitmentDepthChartRepository';

const repositories = {
    disciples: DisciplesRepository,
    roles: RolesRepository,
    depthCharts: DepthChartsRepository,
    bibleStudyPlans: BibleStudyPlansRepository,
    people: PeopleRepository,
    graduationRecords: GraduationRecordsRepository,
    locations: LocationsRepository,
    discipleshipGroups: DiscipleshipGroupsRepository,
    recruitmentDepthCharts: RecruitmentDepthChartRepository,
    // other repositories ...
};

export const RepositoryFactory = {
    get: (name) => repositories[name]
};
